<template>
  <div class="bg-primary tab-header">
    <h5 class="bg-primary p-3 my-auto col-md-4 col-sm-12"> {{ title }} </h5>

    <div class="p-3 pr-4 pd-0 col-md-4 col-sm-6" v-if="checkAuth">
      <b-button style="margin-left: 40%; border-radius: 5px;" variant="info" @click="showFilterModal" >
        {{ $t('WORKFLOW.FILTER') }} <i class="fa fa-filter"></i>
      </b-button>
    </div>

    <!-- <div class="p-3 pr-4 pd-0 col-md-4 col-sm-6 search" v-if="checkAuth">
      <b-button style="border-radius: 5px;" variant="danger" @click="showModal" v-b-tooltip.hover :title="$t('WORKFLOW.DELETE_MULTIPLE')" >
        {{ $t('WORKFLOW.DELETE') }} <i class="fa fa-trash"></i>
      </b-button>
    </div> -->

    <b-modal class="multi-form-del-modal" ref="filterModal" size="md" :title="$t('WORKFLOW.FILTERS')">
      <div class="p-3 pr-5 pd-0 search">
        <b-input-group class="search_type">
          <b-form-select :plain="true"
                         :options="setOptions"
                         v-model="search_type"></b-form-select>
        </b-input-group>
        <b-input-group class="search-text" >
          <b-form-input v-model="searchText" :placeholder="searchPlaceholder" ref="searchInput"/>
        </b-input-group>
      </div>
     <!-- <div class="p-3 pr-5 pd-0 search">
        <b-input-group class="search_type">
          <b-form-select :plain="true"
                         :options="productOptions"
                         v-model="productType"></b-form-select>
        </b-input-group>
      </div>  -->
      
      <div v-if="checkAuth && order === -2" class="p-3 pr-5 pd-0 search">
          <multiselect  :options="triageStatuses" track-by="value" label="text" placeholder="status" v-model="selectedTriageStatus" 
                        :multiple="true">
          </multiselect>                 
      </div>
      <div v-else-if="checkAuth && order === 2" class="p-3 pr-5 pd-0 search">
          <multiselect  :options="esfTriageStatuses" track-by="value" label="text" placeholder="status" v-model="selectedEsfTriageStatus" 
                        :multiple="true">
          </multiselect>                 
      </div>
      <div v-else-if="checkAuth && order ==  1" class="p-3 pr-5 pd-0 search">
        <multiselect  :options="formDocumnetStatuses" track-by="value" label="text" placeholder="status" v-model="selectedAgentStatus" 
                        :multiple="true">
          </multiselect>
      </div>

      <div v-else-if="checkAuth && order ==  -1" class="p-3 pr-5 pd-0 search">
        <multiselect  :options="unmatchStatuses" track-by="value" label="text" placeholder="status" v-model="selectedUnmatchStatus" 
                        :multiple="true">
          </multiselect>
      </div>

      <div class="p-3 pr-5 pd-0 search">
        <b-input-group class="search_type">
          <b-form-select :plain="true"
                         :options="dateRangeOptions"
                         v-model="dateRangeDropDown"></b-form-select>
        </b-input-group>
      </div>
      <div v-if="dateRangeDropDown === 'custom_range'" class="p-3 pr-5 pd-0 search">
        <b-row id = "teamFilter">
          <b-col lg=6>
              <a> Start Date</a>
              <b-form-input ref="filterFromDate" type="date" v-model="filterFromDate" :max="filterToDate || currDate"/>
          </b-col>
          <b-col lg=6>
              <a> End Date</a>
              <b-form-input ref="filterToDate" type="date" v-model="filterToDate" :min="filterFromDate" :max="currDate"/>
          </b-col>
        </b-row>
      </div>
      <div align="right">
        <b-button id= "reset_button" type="reset" size="sm" variant="light" @click="resetbutton()"><i class="fa fa-ban"></i> {{ $t('COMMON.RESET') }}</b-button>
      </div>
      <div slot="modal-footer" align="center" >
        <b-btn variant="secondary" :disabled="dateRangeDropDown === 'custom_range' && !(filterToDate && filterFromDate)"  @click="filterModalApply">
          {{ $t('COMMON.APPLY') }}
        </b-btn>
        <b-btn variant="light"  @click="filterModalClose">
          {{ $t('COMMON.CANCEL') }}
        </b-btn>
      </div>
    </b-modal>

    <b-modal class="multi-form-del-modal" size="lg" ref="MultiFormDelModal" hide-footer :title="$t('WORKFLOW.DELETE_MULTIPLE')" @hidden="onHidden">
      <b-col md="6" offset-md="3">
        <b-input-group>
          <b-col class="p-1" sm="3">
            <label>Title: </label>
          </b-col>
          <b-col class="p-1" sm="9">
            <b-form-input ref="deleteTitleFilter" class="delete-filter" v-model="deleteFilter" placeholder="Title of the form"/>
          </b-col>
          <b-col class="p-1" sm="3">
            <label>From: </label>
          </b-col>
          <b-col class="p-1" sm="9">
            <b-form-input ref="deleteFromDate" class="delete-filter" type="date" v-model="fromDate" :max="toDate || currDate"/>
          </b-col>
          <b-col class="p-1" sm="3">
            <label>To: </label>
          </b-col>
          <b-col class="p-1" sm="9">
            <b-form-input ref="deleteToDate" class="delete-filter" type="date" v-model="toDate" :min="fromDate" :max="currDate"/>
          </b-col>
        </b-input-group>
      </b-col>
      <div id="warn-message" v-if="invalidInputs">Please provide valid inputs.</div>
      <div id="info-message" v-if="!showCheck">
        Found {{deletableForms.length}} {{deletableForms === 1 ? 'form.' : 'forms.'}} Please select the forms to be deleted.
      </div>
      <b-row class="m-3" v-if="!showCheck && deletableForms.length > 0">
        <b-col cols="12">
          <input class="pull-left mt-1 mr-2" type="checkbox" id='select_all' v-model="selectedAll" v-on:change="handleSelectAll" />
          <label class="pull-left" for='select_all'>
            Select All
          </label>
        </b-col>
        <b-col sm="12" md="4" v-for="form in deletableForms" :key="form.id">
          <input class="pull-left mt-1 mr-2" type="checkbox" :id="form.id" :value="form.id" v-model="selectedForms" />
          <a class="pull-left deletable-form" :href="'/process/docs/' + form.id" target="_blank">{{ form.title }}</a>
        </b-col>
      </b-row>
      <b-button-group v-if="showCheck" id="checkGroup">
        <b-button class="secondary" @click="checkDeletableForms">
          Fetch Details
        </b-button>
      </b-button-group>
      <b-button-group v-if="!showCheck" id="deleteGroup">
        <b-button variant="secondary" :disabled="selectedForms.length === 0" @click="deleteMultiForms">
          Delete
        </b-button>
        <b-button sm="12" variant="light" style="margin-left:10px" @click="hideModal">
          Cancel
        </b-button>
      </b-button-group>
    </b-modal>
  </div>
</template>

<script>
import svg from '../../_svg.js'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  data () {
    return {
      svg: svg,
      showClear: false,
      showCheck: true,
      currDate: moment().format('YYYY-MM-DD').toString(),
      deleteFilter: '',
      fromDate: '',
      toDate: '',
      deletableForms: [],
      invalidInputs: false,
      selectedForms: [],
      selectedAll: false,
      matchOptions: [],
      search_type: 'title',
      filterToDate: '',
      filterFromDate: '',
      searchText: '',
      dateRangeDropDown: null,
      productType: '',
      searchPlaceholder: this.$t('WORKFLOW.SEARCH'),
      dateRangeOptions: [
        { value: null, text: 'Select Date Range' },
        { value: 'last_hour', text: 'Last Hour' },
        { value: 'last_6_hour', text: 'Last 6 Hour' },
        { value: 'today', text: 'Today' },
        { value: 'yesterday', text: 'Yesterday' },
        { value: 'this_week', text: 'This Week' },
        { value: 'last_week', text: 'Last Week' },
        { value: 'this_month', text: 'This Month' },
        { value: 'custom_range', text: 'Custom Range' }
      ],
      shortcuts: [
        { text: 'last_hour', fromDate: moment().subtract(1, 'hour'), toDate: moment() },
        { text: 'last_6_hour', fromDate: moment().subtract(6, 'hour'), toDate: moment() },
        { text: 'today', fromDate: moment().startOf('day'), toDate: moment() },
        { text: 'yesterday', fromDate: moment().subtract(1, 'day').startOf('day'), toDate: moment().subtract(1, 'day').endOf('day') },
        { text: 'this_week', fromDate: moment().startOf('week'), toDate: moment() },
        { text: 'last_week', fromDate: moment().subtract(1, 'week').startOf('week'), toDate: moment().subtract(1, 'week').endOf('week').endOf('day') },
        { text: 'this_month', fromDate: moment().startOf('month'), toDate: moment().endOf('month') }
      ],
      productOptions: [],
      engagementPrograms: [],
      selectedEngagementProgram: null,
      defaultTriagestatus: [
        { value: 1, text: 'New' },
        { value: 2, text: 'In Progress' },
        { value: 3, text: 'Partially Completed' },
        { value: 4, text: 'Completed' },
        { value: 6, text: 'Recalled' },
        { value: 12, text: 'Triaged' },
        { value: 7, text: 'Integration Success' },
        { value: 8, text: 'Integration Failed' },
        { value: 5, text: 'Rejected' }
      ],
      selectedTriageStatus: [],
      defaultAgentstatus: [
        { value: 11, text: 'Pending' },
        { value: 2, text: 'In Progress' },
        { value: 10, text: 'Validated' },
        { value: 6, text: 'Recalled' },
        { value: 7, text: 'Integration Success' },
        { value: 8, text: 'Integration Failed' },
        { value: 5, text: 'Rejected' }
      ],
      selectedAgentStatus: [],
      defaultUnmatchedstatus: [
        { value: 11, text: 'Pending' },
        { value: 2, text: 'In Progress' },
        { value: 10, text: 'Validated' },
        { value: 6, text: 'Recalled' },
        { value: 7, text: 'Integration Success' },
        { value: 8, text: 'Integration Failed' },
        { value: 5, text: 'Rejected' }
      ],
      selectedUnmatchStatus: [],
      defaultEsfTriagestatus: [
        { value: 1, text: 'New' },
        { value: 2, text: 'In Progress' },
        { value: 3, text: 'Partially Completed' },
        { value: 4, text: 'Completed' },
        { value: 6, text: 'Recalled' },
        { value: 7, text: 'Integration Success' },
        { value: 8, text: 'Integration Failed' },
        { value: 5, text: 'Rejected' }
      ],
      selectedEsfTriageStatus: [],
      triageStatuses: [
        { value: 1, text: 'New' },
        { value: 2, text: 'In Progress' },
        { value: 3, text: 'Partially Completed' },
        { value: 4, text: 'Completed' },
        { value: 5, text: 'Rejected' },
        { value: 6, text: 'Recalled' },
        { value: 9, text: 'Document Moved To SF' },
        { value: 12, text: 'Triaged' },
        { value: 7, text: 'Integration Success' },
        { value: 8, text: 'Integration Failed' }
      ],
      formDocumnetStatuses: [
        { value: 11, text: 'Pending' },
        { value: 2, text: 'In Progress' },
        { value: 10, text: 'Validated' },
        { value: 7, text: 'Integration Success' },
        { value: 8, text: 'Integration Failed' },
        { value: 5, text: 'Rejected' },
        { value: 6, text: 'Recalled' },
        { value: 9, text: 'Document Moved To SF' }
      ],
      unmatchStatuses: [
        { value: 11, text: 'Pending' },
        { value: 2, text: 'In Progress' },
        { value: 10, text: 'Validated' },
        { value: 7, text: 'Integration Success' },
        { value: 8, text: 'Integration Failed' },
        { value: 5, text: 'Rejected' },
        { value: 6, text: 'Recalled' },
        { value: 9, text: 'Document Moved To SF' }
      ],
      esfTriageStatuses: [
        { value: 1, text: 'New' },
        { value: 2, text: 'In Progress' },
        { value: 3, text: 'Partially Completed' },
        { value: 4, text: 'Completed' },
        { value: 5, text: 'Rejected' },
        { value: 6, text: 'Recalled' },
        { value: 9, text: 'Document Moved To SF' },
        { value: 7, text: 'Integration Success' },
        { value: 8, text: 'Integration Failed' }
      ]
    }
  },
  props: ['title', 'eventBus', 'order', 'tabIndex'],
  computed: {
    ...mapGetters(['idToken', 'userRoleOrder', 'selectTriageStatus', 'selectAgentStatus', 'selectUnmatchStatus', 'selectEsfTriageStatus']),
    checkAuth: function () {
      let order = parseInt(this.$props.order)
      let userRoleOrder = parseInt(this.userRoleOrder)
      return ((order === -2) || (order === -1) || (order === 2) || (order <= userRoleOrder))
    },
    setOptions () {
      this.matchOptions = [
        { text: this.$t('WORKFLOW.TITLE'), value: 'title' }
      ]
      return this.matchOptions
    }
  },
  watch: {
    selectedForms: function () {
      this.selectedAll = ((this.deletableForms.length > 0) && (this.deletableForms.length === this.selectedForms.length))
    },
    deleteFilter: function () {
      this.handleFilterUpdate()
    },
    fromDate: function () {
      this.handleFilterUpdate()
    },
    toDate: function () {
      this.handleFilterUpdate()
    },
    search_type: function () {
      if (this.search_type === 'faxnum') {
        this.searchPlaceholder = this.$t('WORKFLOW.ENTER_FAX_NUMBER')
      } else {
        this.searchPlaceholder = this.$t('WORKFLOW.SEARCH')
      }
    }
  },
  /*
  created () {
    Vue.axios.get('/form_docs/fetch_product_types', { headers: { Authorization: `Bearer ${this.idToken}` } })
      .then(res => {
        if (res.status === 200) {
          this.productOptions = [{ value: '', text: 'Select Product' }].concat(res.data.product_list)
        }
      }).catch(error => {
        console.log(error)
        if (error.status === 401) {
          Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
        } else {
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        }
      })
  },
  */
  created () {
    this.setSelectedStatuses()
  },
  mounted () {
    this.eventBus.$on('resetFilter', this.clearFilter)
    this.eventBus.$on('resetFilterModalValues', this.resetFilters)
  },
  methods: {
    clearFilter () {
      this.$refs.searchInput.$el.value = ''
      this.$emit('filterInput', '')
      this.applyFilters()
    },
    resetbutton () {
      this.selectedTriageStatus = this.defaultTriagestatus
      this.$store.commit('setselectTriageStatus', this.selectedTriageStatus)
      this.selectedEsfTriageStatus = this.defaultEsfTriagestatus
      this.$store.commit('setselectEsfTriageStatus', this.selectedEsfTriageStatus)
      this.selectedAgentStatus = this.defaultAgentstatus
      this.$store.commit('setselectAgentStatus', this.selectedAgentStatus)
      this.selectedUnmatchStatus = this.defaultUnmatchedstatus
      this.$store.commit('setselectUnmatchStatus', this.selectedUnmatchStatus)
      this.resetFilters(false)
    },
    resetFilters (isTabChange = true) {
      if (isTabChange) {
        this.setSelectedStatuses()
      }
      this.search_type = 'title'
      this.searchText = ''
      this.searchPlaceholder = this.$t('WORKFLOW.SEARCH')
      this.selectedDocStatus = [
        { value: 1, text: 'New' },
        { value: 2, text: 'In Progress' },
        { value: 6, text: 'Recalled' }
      ]
      this.selectedFormStatus = [
        { value: 11, text: 'Pending' },
        { value: 2, text: 'In Progress' },
        { value: 10, text: 'Validated' },
        { value: 6, text: 'Recalled' },
        { value: 7, text: 'Integration Success' },
        { value: 8, text: 'Integration Failed' }
      ]
      this.selectedDocLockStatus = ''
      this.fromDate = ''
      this.toDate = ''
      this.dateRangeDropDown = null
      this.toDatePlaceholder = 'mm/dd/yyyy'
      this.fromDatePlaceholder = 'mm/dd/yyyy'
      this.filterToDate = ''
      this.filterFromDate = ''
    },
    setSelectedStatuses () {
      if (this.selectTriageStatus && this.selectTriageStatus.length > 0) {
        this.selectedTriageStatus = this.selectTriageStatus
      } else {
        this.selectedTriageStatus = this.defaultTriagestatus
      }

      const validEsfValues = this.esfTriageStatuses.map(status => status.value)
      const storedEsfStatuses = (this.selectEsfTriageStatus || []).filter(status => validEsfValues.includes(status.value))
      if (storedEsfStatuses.length > 0) {
        this.selectedEsfTriageStatus = storedEsfStatuses
      } else {
        this.selectedEsfTriageStatus = this.defaultEsfTriagestatus
      }

      if (this.selectAgentStatus && this.selectAgentStatus.length > 0) {
        this.selectedAgentStatus = this.selectAgentStatus
      } else {
        this.selectedAgentStatus = this.defaultAgentstatus
      }
      if (this.selectUnmatchStatus && this.selectUnmatchStatus.length > 0) {
        this.selectedUnmatchStatus = this.selectUnmatchStatus
      } else {
        this.selectedUnmatchStatus = this.defaultUnmatchedstatus
      }
    },
    showModal () {
      this.$refs.MultiFormDelModal.show()
    },
    hideModal () {
      this.$refs.MultiFormDelModal.hide()
    },
    showFilterModal () {
      this.$refs.filterModal.show()
    },
    filterModalApply () {
      this.applyFilters()
      this.$refs.filterModal.hide()
    },
    applyFilters () {
      let values = []
      if (this.order === -2) {
        values = this.selectedTriageStatus.map((status) => status.value)
        this.$store.commit('setselectTriageStatus', this.selectedTriageStatus)
      } else if (this.order === 2) {
        values = this.selectedEsfTriageStatus.map((status) => status.value)
        this.$store.commit('setselectEsfTriageStatus', this.selectedEsfTriageStatus)
      } else if (this.order === 1) {
        values = this.selectedAgentStatus.map((status) => status.value)
        this.$store.commit('setselectAgentStatus', this.selectedAgentStatus)
      } else {
        values = this.selectedUnmatchStatus.map((status) => status.value)
        this.$store.commit('setselectUnmatchStatus', this.selectedUnmatchStatus)
      }
      let date = this.shortcuts.filter(type => { if (type.text === this.dateRangeDropDown) return type })
      let fromDate = null
      let toDate = null
      if (date.length > 0) {
        fromDate = date[0].fromDate.format('YYYY-MM-DD HH:mm:ss')
        toDate = date[0].toDate.format('YYYY-MM-DD HH:mm:ss')
      } else {
        fromDate = this.filterFromDate
        toDate = moment(this.filterToDate).endOf('day')
      }
      this.$emit('applyFilters', this.search_type, this.searchText, this.dateRangeDropDown, fromDate, toDate, this.selectedEngagementProgram, this.productType, values)
    },
    filterModalClose () {
      this.$refs.filterModal.hide()
    },
    onHidden () {
      this.deleteFilter = ''
      this.fromDate = ''
      this.toDate = ''
      this.showCheck = true
      this.$refs.deleteTitleFilter.$el.value = ''
      this.$refs.deleteFromDate.$el.value = ''
      this.$refs.deleteToDate.$el.value = ''
    },
    handleSelectAll: function () {
      if (this.selectedAll) {
        this.selectedForms = this.deletableForms.map(function (form) { return form.id })
      } else {
        this.selectedForms = []
      }
    },
    handleFilterUpdate: function () {
      this.showCheck = true
      this.deletableForms = []
      this.selectedForms = []
      this.selectedAll = false
      this.invalidInputs = false
    },
    checkDeletableForms () {
      let filter = this.deleteFilter
      let fromDate = this.fromDate
      let toDate = this.toDate
      let isValid = (fromDate && toDate && filter) || (fromDate && toDate) || (filter && !fromDate && !toDate)
      if (isValid) {
        let vm = this
        let order = this.$props.order
        var status = order > 0 ? 'stage_' + order : 'unmatched'
        Vue.axios.get('/form_docs/deletable_forms?status=' + status + '&filter=' + encodeURIComponent(filter.toString()) + '&fromDate=' + this.fromDate + '&toDate=' + this.toDate, { headers: { Authorization: `Bearer ${vm.idToken}` } })
          .then(res => {
            if (res.status === 200) {
              this.deletableForms = res.data.form_docs
              this.showCheck = false
            }
          }).catch(error => {
            console.log(error)
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      } else {
        this.invalidInputs = true
      }
    },
    deleteMultiForms () {
      let vm = this
      Vue.axios
        .post('/form_docs/destroy_multi', { ids: this.selectedForms }, { headers: { Authorization: `Bearer ${vm.idToken}` } })
        .then(res => {
          if (res.status === 200) {
            this.$refs.MultiFormDelModal.hide()
            Vue.toasted.show(res.data.status + ' ' + res.data.deleted + ' forms.')
            this.$emit('refreshTab', this.$props.tabIndex, this.$props.order)
          }
        }).catch(error => {
          console.log(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
    display: flex;
    justify-content: flex-end;

    .clear-btn {
      font-size: 1.3rem;
      padding: 5px 0px;
      cursor: pointer;
      z-index: 10;
      right: 1rem;
      position: absolute;
    }

    .search-icon {
      font-size: 1.3rem;
      padding: 6px 10px;
    }
  }

  .search-text {
    padding: 6px 15px;
    border-color: #939dad ;
  }

  .tab-header h5{
    text-transform: uppercase;
  }

  .tab-header{
    display: flex;
    justify-content: space-between;
  }

  .multi-form-del-modal{
    color: black;
  }

  .delete-filter{
    border-radius: 20px;
    padding: 8px 15px;
  }

  .deletable-form:hover {
    text-decoration: underline;
  }

  .search_type {
    padding: 6px 10px;
  }

  #warn-message{
    color: red;
  }

  #info-message{
    color: #0095ff;
  }

  #checkGroup,
  #deleteGroup{
    margin-top : 20px;
  }

  #reset_button{
    padding: 0.25rem 0.5rem;
    margin-right: 50px;
    margin-top: 0.625rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/FormsSearchBar.vue